import React, { forwardRef } from "react"
import Spacer from "../components/spacer"

const Footer = forwardRef(({ optimised = false, ...props }, ref) => {
  return (
    <FooterWrapper optimised={optimised}>
      <Spacer className='m-hide' />
      <Spacer />
      <div className='footer'>
        <div ref={ref} className='footer--text uppercase m0 h1 overflow-hidden'>
          <div className='footer-text--marquee'>
            <div className='inner text-light'>
              {Array(5).fill(1).map((el, i) => (
                <span key={i}><span style={{ color: 'transparent' }}>A</span>Groundcrew ©2018—{new Date().getFullYear()}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </FooterWrapper>
  )
})

const FooterWrapper = ({ optimised, children }) => {
  if (optimised) {
    return (
      <div data-scroll-section>
        {children}
      </div>
    )
  } else {
    return children
  }
}

export default Footer
